import { useEffect, useState } from "react";
import { ImageUpload } from "../ui/forms/files/ImageUpload";
import { createLeauge, updateLeauge } from "../../services/leaguesAPI";
import { toast } from "react-toastify";
import { Button } from "../ui/btns/Button";
// CREATE LEAGUE IS NOW USED FOR UDPATE ALSO
export const CreateLeague = ({ league, id, handleClose, fetchLeague }) => {
  const [isPending, setIsPending] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [imageFile, setImageFile] = useState(null);

  // SET INITIAL DATA (FILL BY DEFAULT DATA FOR UPDATE)
  useEffect(() => {
    if (league) {
      setFormData({
        name: league.name || "",
        description: league.description || "",
      });
    }
  }, [league]);

  const handleImageInput = (file) => {
    // const file = e.target.files[0];
    setImageFile(file);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    setIsPending(true);
    e.preventDefault();
    if (!formData.name) {
      toast.error("Name is required", { autoClose: 5000 });
      setIsPending(false);
      return;
    }

    // Create a new FormData object
    const formDataToSend = new FormData();

    // Append form data fields
    formDataToSend.append("name", formData.name);
    formDataToSend.append("description", formData.description);

    // Append the image file, if selected
    if (imageFile) {
      formDataToSend.append("image", imageFile);
    }

    let response;
    if (id) {
      response = await updateLeauge(id, formDataToSend);
      if (!response?.success) {
        toast.error("Error updating league", { autoClose: 5000 });
        setIsPending(false);
        return;
      }
      toast.success("League updated successfully");
      fetchLeague();
      handleClose();
      setIsPending(false);
    } else {
      response = await createLeauge(formDataToSend);
      if (!response?.success) {
        toast.error("Error creating league", { autoClose: 5000 });
        setIsPending(false);
        return;
      }
      toast.success("League created successfully");
      setFormData({ name: "", description: "" });
      setImageFile(null);
      setIsPending(false);
    }

    console.log(response);
  };

  return (
    <div className="flex flex-col items-center justify-center p-6">
      <h1 className="font-heading text-xl font-black uppercase tracking-wide text-flyers-orange mb-4">
        {id ? "Update League" : "Create League"}
      </h1>
      <form
        onSubmit={handleSubmit}
        className="bg-flyers-charcoal border border-flyers-dark-gray p-6 rounded-lg w-full max-w-md"
      >
        <div className="mb-4">
          <label htmlFor="name" className="label">
            Name
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter League Name"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="description" className="label">
            Description
          </label>
          <input
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter League Description"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <ImageUpload labelText="Select Team Image" fileChange={handleImageInput} />
        </div>
        <Button variant="primary" type="submit" className="w-full" disabled={isPending}>
          {id ? "Update League" : "Create League"} {isPending && "..."}
        </Button>
      </form>
    </div>
  );
};
